// @spec GHG-STR-003
'use client';

import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/ghg-facilities')({
  component: () => <Navigate to="/ghg/setup" replace />,
});
